import { Trans } from "@lingui/macro";

import { useLocalize } from "../../content/useLocalize";
import { SKILL_UPGRADE_COST } from "../../engine/skills";
import type { Skill } from "../../types";
import { Button } from "../common/Button";
import { Modal } from "../common/Modal";
import { cx } from "../common/cx";
import styles from "./SkillUpgradeModal.module.css";

export interface SkillUpgradeModalProps {
  skill: Skill;
  currentLevel: number;
  skillPoints: number;
  onConfirm: () => void;
  onClose: () => void;
}

export function SkillUpgradeModal({
  skill,
  currentLevel,
  skillPoints,
  onConfirm,
  onClose,
}: SkillUpgradeModalProps): JSX.Element {
  const t = useLocalize();
  const nextEffect = skill.effects[currentLevel];

  return (
    <Modal
      title={t(skill.name)}
      onClose={onClose}
      actions={
        <>
          <Button variant="ghost" size="small" onClick={onClose}>
            <Trans>Отмена</Trans>
          </Button>
          <Button variant="primary" size="small" onClick={onConfirm}>
            <Trans>Прокачать</Trans>
          </Button>
        </>
      }
    >
      {nextEffect && <p className={styles.effect}>{t(nextEffect)}</p>}
      <div className={styles.rows}>
        <div className={styles.row}>
          <span>
            <Trans>Уровень</Trans>
          </span>
          <span className="mono">
            {currentLevel} → {currentLevel + 1}
          </span>
        </div>
        <div className={styles.row}>
          <span>
            <Trans>Очки навыка</Trans>
          </span>
          <span className="mono">-{SKILL_UPGRADE_COST}</span>
        </div>
        <div className={styles.row}>
          <span>
            <Trans>Останется</Trans>
          </span>
          <span className={cx("mono", styles.remain)}>{skillPoints - SKILL_UPGRADE_COST}</span>
        </div>
      </div>
    </Modal>
  );
}
